import React, { useState, useEffect } from 'react'
import Chart from 'apexcharts'

export const StockValueGraphView = (props) => {

    const [options, setOptions] = useState({ //data on the x-axis
        chart: { id: 'bar-chart' },
        dataLabels: {
            formatter: function (val) {
                return '£' + val.toLocaleString("en-US")
            }
        },
        xaxis: {
            categories: [],
        },
        yaxis: [
            {
                labels: {
                    formatter: function (val) {
                        return '£' + val.toLocaleString("en-US")
                    }
                }
            }
        ]

    })

    const [series, setSeries] = useState([ //data on the y-axis
        {
            name: "Value of stock",
            data: []
        }
    ])

    //update labels when changed (and initial load)
    useEffect(() => {
        setOptions({
            ...options,
            title: {
                text: props.lastUpdated ? 'Last updated: ' + props.lastUpdated.toString() : ''
            },
            xaxis: {
                ...options.xaxis,
                categories: props[props.selectedType]
            },

        })
    }, [props.selectedType, props.loading])

    //update series data when changed (and initial load)
    useEffect(() => {
        setSeries([
            {
                name: "Value of stock",
                data: props.seriesData
            }
        ])

    }, [props.seriesData])


    return <div>
        <div className="app">
            <div className="row">
                <div className="mixed-chart">
                    {!props.loading && <Chart
                        options={options}
                        series={series}
                        type="bar"
                        width={1600}
                        height={800}
                    />}
                </div>
            </div>
        </div>
        <div>Total value is £{props.seriesData.reduce((acc, val) => acc += val, 0).toLocaleString("en-US")}</div>
        <div>
            <label htmlFor="dimensions">Choose a dimension:</label>

            <select disabled={props.loading} name="dimensions" id="dimensions" onChange={(e) => { props.onSelectDimension(e) }}>
                <option value="brands">Brands</option>
                <option value="suppliers">Suppliers</option>
                <option value="categories">Categories</option>

            </select>
        </div>
        <div>
            <label htmlFor="dates">Choose a date:</label>
            <select disabled={props.loading} value={props.selectedDate} name="dates" id="dates" onChange={(e) => { props.onSelectDates(e) } }>
                {props.dates.map((date) => {
                    return <option value={date}>{date.slice(0,10)}</option>
                })}

            </select>
        </div>
    </div>
}



